import React, { useEffect, useRef, useState } from 'react';
import { LANGS, useLang } from './i18n';
import './site.css';

export default function LangSwitcher() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  return (
    <div className="lang-switcher" ref={ref}>
      <button type="button" className="lang-switcher__btn" aria-label={t('nav.language')}
        aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(!open)}>
        <span className="lang-switcher__inner">
          <i className="fas fa-globe" /> <span className="lang-switcher__code">{cur.short}</span>
          <i className="fas fa-caret-down" />
        </span>
      </button>
      {open && (
        <ul className="lang-switcher__list" role="listbox">
          {LANGS.map((l) => (
            <li key={l.code} role="option" aria-selected={l.code === lang}>
              <button type="button" className={l.code === lang ? 'is-active' : ''}
                onClick={() => { setLang(l.code); setOpen(false); }}>
                <span className="lang-switcher__code">{l.short}</span> {l.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
